export default __webpack_public_path__ + "static/media/reports-non-hover.64effb1a.svg";